import api from '../axios.config';
import { API_ENDPOINTS } from './endpoints';

export const ReferenceDataService = {
  getReferenceData: async ({ include, exclude } = {}) => {
    const params = new URLSearchParams();
    (include || []).forEach((key) => params.append('include', key));
    (exclude || []).forEach((key) => params.append('exclude', key));
    const qs = params.toString();
    const url = qs
      ? `${API_ENDPOINTS.REFERENCE_DATA.GET}?${qs}`
      : API_ENDPOINTS.REFERENCE_DATA.GET;
    return api.get(url);
  },
};
